const React = require('react');
const { StyleSheetManager } = require('styled-components');

exports.wrapRootElement = ({ element }) => (
  <StyleSheetManager disableVendorPrefixes={process.env.NODE_ENV === 'development'}>{element}</StyleSheetManager>
);
